import React from 'react';
import { Box, Stack, Button, Collapse, Tooltip } from '@mui/material';
import { useAuthenticated, useResponsive } from '../../../services/hooks';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const LoginOrRegister = () => {
  const { isAuthenticated } = useAuthenticated();
  const isDesktop = useResponsive('up', 'lg');

  const [expanded, setExpanded] = React.useState(false);
  const [type, setType] = React.useState('login');

  const handleExpandClick = formType => {
    if (expanded && formType !== type) {
      setType(formType);
    } else {
      setExpanded(!expanded);
      setType(formType);
    }


  };

  if (isAuthenticated()) {
    return null;
  }

  return (
    <Box sx={{ m: 2, mt: 1 }}>
      <Stack direction={isDesktop ? 'row' : 'column'} justifyContent="space-around" alignItems="center" spacing={2}>
        <Stack direction="row" spacing={4} alignItems="center">
          <Button variant="contained" onClick={() => handleExpandClick('login')} style={{ textTransform: 'none' }}>Zaloguj się</Button>
          <Tooltip title="Opcja dla klientów już zarejestrowanych. Umożliwia dostęp do historii wyjazdów oraz w kolejnych latach ułatwia wypełnianie formularza." enterTouchDelay={0}>
            <HelpOutlineIcon />
          </Tooltip>
        </Stack>
        <Button variant="contained" onClick={() => handleExpandClick('register')} style={{ textTransform: 'none' }}>Zarejestruj się i zyskaj dostęp do panelu klienta</Button>
      </Stack>
      {expanded ? <Box height={40}/> : null}
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {type === 'login' ? <LoginForm /> : <RegisterForm />}
      </Collapse>
    </Box>
  );
};

export default LoginOrRegister;
